/**
 * NotificationReportUserItem
 *
 * reportUser — `notification_report_user_item.dart:23-90`.
 * Leading: a `report.png` icon over a circular `backgroundColorLight` surface
 * (no avatar / user tap). Static title + subtitle; subtitle gets ` - {date}`
 * appended. No trailing thumbnail.
 */
import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { useDateFormatters } from '@/presentation/utils/useDateFormatters';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { NotificationRowLayout } from '../NotificationRowLayout';
import { NotificationLeadingIcon } from './shared/NotificationLeadingIcon';
import type { NotificationItemProps } from './notificationItemProps';

export const NotificationReportUserItem: React.FC<NotificationItemProps> = ({
  notification,
  onItemTap,
}) => {
  const { l10n } = useLocale();
  const { formatDate } = useDateFormatters();
  const { theme } = useTheme();
  const n = l10n.inbox.notifications;

  const { info } = notification;
  const subtitle = `${n.reportUserSubtitle} - ${formatDate(info.timestamp)}`;

  return (
    <NotificationRowLayout
      leading={
        <NotificationLeadingIcon
          iconPath="/assets/images/report.png"
          iconColor={theme.disabled}
          circleBackground
        />
      }
      title={n.reportUserTitle}
      subtitle={subtitle}
      onItemTap={onItemTap ? () => onItemTap(notification) : undefined}
    />
  );
};
